import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles.css';

ReactDOM.render(<App />, document.getElementById('root'));

// Directory structure:
// src/
// ├── App.js
// ├── components/
// │   ├── HomePage.js
// │   ├── ProfilePage.js
// │   ├── PdfViewer.js
// │   ├── UploadPage.js
// │   ├── LoginPage.js
// │   └── RegisterPage.js
// ├── context/
// │   └── AuthContext.js
// ├── styles.css
// └── index.js